module.exports = __webpack_public_path__ + "img/rate_platinum.e62655bb.jpg";